<div class="container">
  <div *ngIf="!loading">
    <div *ngIf="emailChange" class="card card-login mx-auto mt-3 login_form">
      <div class="card-body">
        <h3 class="text-center">{{"email-confirmation.confirm" | translate}}</h3>
        <hr>
        <div class="form-group">
          <div *ngIf="emailConfirmed" class="text-center">
            <h5>{{ "email-confirmation.email-confirmed" | translate}}</h5>
          </div>
          <div *ngIf="!emailConfirmed" class="text-center">
            <h5>{{ "email-confirmation.no-longer-valid" | translate}}</h5>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!emailChange" class="card card-login mx-auto mt-3 login_form">
      <div class="card-body">
        <h3 class="text-center">{{"email-confirmation.confirm" | translate}}</h3>
        <hr>
        <div class="form-group">
          <div *ngIf="emailConfirmed" align="center">
            <h5>{{ "email-confirmation.email-confirmed" | translate}}</h5>
          </div>
          <div *ngIf="!emailConfirmed" align="center">
            <h5>{{ "email-confirmation.no-longer-valid" | translate}}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="loading" class="row">
    <div class="col text-center">
      <i class="fas fa-spinner fa-spin fa-4x"></i>
    </div>
  </div>
</div>
